export enum UICrumbType {
    SOCIAL_LIVES = 'socialLives',
    SOCIAL_FRIENDS = 'socialFriends',
    SOCIAL_NEWS = 'socialNews',
    MISSIONS = 'missions',
    CARDS = 'cards',
}

export type UICrumb = {
    type: UICrumbType;
    crumb?: UICrumb;
};
